import { checkoutQueries } from 'modules/checkout/presentation/constants';

export default function getBudgetScopedQueryKeys(
  budgetId: number,
): readonly unknown[][] {
  return [
    [...checkoutQueries.budget(budgetId)],
    [...checkoutQueries.automaticDebitInstallments(budgetId)],
    [...checkoutQueries.budgetStatus(budgetId)],
    [...checkoutQueries.cardInstallmentsByBudget(budgetId)],
  ];
}
